// extracted by mini-css-extract-plugin
module.exports =  {"information_border":"MessageInformation-module__information_border___CmHpy"};